module.exports = __webpack_public_path__ + "img/aweber.964e4e17.png";